var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneAndDesktopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 72.9814,
    rx: 4.83323,
    fill: "#000",
    stroke: "#F8F6F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.3936H81",
    stroke: "#F8F6F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.46717,
    y: 21.5743,
    width: 37.6018,
    height: 5.22247,
    rx: 1.17941,
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.425532,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.67993,
    y: 30.5811,
    width: 37.1763,
    height: 4.79694,
    rx: 0.966647,
    fill: "#DCD2FF",
    stroke: "#DCD2FF",
    strokeWidth: 0.967383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.46692,
    y: 39.1632,
    width: 37.6018,
    height: 5.22247,
    rx: 1.17941,
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.425532,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.46692,
    y: 47.9572,
    width: 37.6018,
    height: 5.22247,
    rx: 1.17941,
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.425532,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2207,
    y: 16.9883,
    width: 41.9445,
    height: 64.0099,
    rx: 4.83323,
    fill: "#000",
    stroke: "#F8F6F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4702,
    y: 42.9717,
    width: 35.1507,
    height: 4.79694,
    rx: 0.966647,
    fill: "#5B5B5B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4702,
    y: 50.9668,
    width: 35.1507,
    height: 4.79694,
    rx: 0.966647,
    fill: "#5B5B5B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4702,
    y: 58.9619,
    width: 35.1776,
    height: 4.79694,
    rx: 0.966647,
    fill: "#5B5B5B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4705,
    y: 22.1846,
    width: 35.1507,
    height: 17.1889,
    rx: 0.967383,
    fill: "#DCD2FF",
    stroke: "#DCD2FF",
    strokeWidth: 0.967383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAndDesktopIcon);
export default __webpack_public_path__ + "static/media/phone-and-desktop-icon.fa5d0b7ed3023869a014530b3839efd3.svg";
export { ForwardRef as ReactComponent };